import React from "react";
import HeroSection from "./HeroSection.js";
import WhoWeAre from "./WhoWeAre.js";
import OurPrograms from "./OurPrograms.js";
import WhyChooseUs from "./WhyChooseUs.js";
import Reviews from "./Reviews.js";

const AboutUs = () => {
  return (
    <div>
      <HeroSection />
      <WhoWeAre />
      <OurPrograms />
      <WhyChooseUs/>
      <Reviews/>

    </div>
  );
};

export default AboutUs;


